export const NOT_VALIDATED = 'not-validated';
export const INVALID = 'invalid';
export const VALID = 'valid';
export const VALIDATION_DISABLED = 'disabled';
